export const SINGLE_PHASE = "Single";
export const TYPE_ABC35 = "ABC 35";
export const GROUP_SERVICE_OH = "service-overhead";
export const GROUP_MAINS_OH = "mains-overhead";
export const GROUP_SERVICE_UG = "service-underground";
export const GROUP_MAINS_UG = "mains-underground";
